import { api } from '../../../services/api/client';

export interface McpInfo {
  token: string;
  path: string;
  server_name?: string;
}

export async function adminGetMcpInfo(): Promise<McpInfo> {
  const { data } = await api.get<McpInfo>('/admin/mcp/info');
  return data;
}

export async function adminRotateMcpToken(): Promise<McpInfo> {
  const { data } = await api.post<McpInfo>('/admin/mcp/rotate');
  return data;
}
